/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { BriefcaseIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/xdp';

const styles = {
  itemTitle: () => css`
    padding: var(--cds-spacing-100) 0;
  `,
  icon: css`
    height: 24px;
    width: 24px;
  `,
};

const ShareableCaseStudyDetailItem = () => {
  return (
    <React.Fragment>
      <BriefcaseIcon css={styles.icon} />
      <Typography2 variant="subtitleMedium" css={styles.itemTitle} component="div">
        {_t('Shareable work sample')}
      </Typography2>
      <Typography2 component="p" variant="bodySecondary" color="supportText">
        {_t('Add to your Coursera profile')}
      </Typography2>
    </React.Fragment>
  );
};

export default ShareableCaseStudyDetailItem;
